import { i18n } from "../../../translate/i18n";

const t = (key) => i18n.t(`financial.checkout.${key}`);

export default {
  formId: 'checkoutForm',
  formField: {
    firstName: {
      name: 'firstName',
      get label() { return t("fullName"); },
      get requiredErrorMsg() { return t("fullNameRequired"); }
    },
    lastName: {
      name: 'lastName',
      label: 'Last name*',
      requiredErrorMsg: 'Last name is required'
    },
    address1: {
      name: 'address2',
      get label() { return t("street"); },
      get requiredErrorMsg() { return t("streetRequired"); }
    },

    city: {
      name: 'city',
      get label() { return t("city"); },
      get requiredErrorMsg() { return t("cityRequired"); }
    },
    state: {
      name: 'state',
      get label() { return t("state"); },
      get requiredErrorMsg() { return t("stateRequired"); }
    },
    zipcode: {
      name: 'zipcode',
      get label() { return t("zip"); },
      get requiredErrorMsg() { return t("zipRequired"); },
      get invalidErrorMsg() { return t("zipInvalid"); }
    },
    country: {
      name: 'country',
      get label() { return t("country"); },
      get requiredErrorMsg() { return t("countryRequired"); }
    },
    useAddressForPaymentDetails: {
      name: 'useAddressForPaymentDetails',
      label: 'Use this address for payment details'
    },
    invoiceId: {
      name: 'invoiceId',
      label: 'Use this invoiceId'
    },
    nameOnCard: {
      name: 'nameOnCard',
      label: 'Name on card*',
      requiredErrorMsg: 'Name on card is required'
    },
    cardNumber: {
      name: 'cardNumber',
      label: 'Card number*',
      requiredErrorMsg: 'Card number is required',
      invalidErrorMsg: 'Card number is not valid (e.g. 4111111111111)'
    },
    expiryDate: {
      name: 'expiryDate',
      label: 'Expiry date*',
      requiredErrorMsg: 'Expiry date is required',
      invalidErrorMsg: 'Expiry date is not valid'
    },
    cvv: {
      name: 'cvv',
      label: 'CVV*',
      requiredErrorMsg: 'CVV is required',
      invalidErrorMsg: 'CVV is invalid (e.g. 357)'
    }
  }
};
